import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';

import Gift from '@ertelecom/ui-react/components/blocks/gift';

export const GiftStyled = styled(Gift)`
    margin: ${props => props.margin || '0'};
    height: ${props => props.height || 'auto'};
    background-size: auto;
`;

export const GiftImg = styled.div`
    width: calc(100% + 48px);
    margin-top: -24px;
    margin-left: -24px;
    margin-right: -24px;
    background: url(${props => props.src}) no-repeat;
    background-size: cover;
    background-position: center;
    border-radius: 8px 8px 0 0;
`;

export const GiftDate = styled.div`
    font-size: 14px;
    font-family: ${FONTS.light};
    height: 20px;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: flex-end;
    margin-top: 20px;
`;

export const GiftTitle = styled.div`
    font-family: ${FONTS.medium};
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: ${COLORS.black};
`;

export const GiftDesc = styled.div`
    margin-top: 10px;
    color: ${COLORS.darkGrey};
    font-family: ${FONTS.light};
    line-height: normal;
`;

export const EndText = styled.p`
    font-size: 16px;
    font-family: ${FONTS.light};
    margin: 0 0 10px;
`;

export const NewOffer = styled.div`
    position: absolute;
    top: 20px;
    left: 20px;
    background: #DB5858;
    border-radius: 2px;
    color: ${COLORS.white};
    font-size: 14px;
    line-height: 14px;
    padding: 5px 10px;
`;
